/* eslint-disable no-array-constructor */
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";

function SchedulePostDialog({ setSchedule, show, onHide, schedule, drafPost }) {
  const [schedulePostMinutes, setSchedulePostMinutes] = useState(
    schedule ? schedule.minutes : 0
  );
  const [schedulePostDate, setSchedulePostDate] = useState(
    schedule ? schedule.date : null
  );
  const [schedulePostHours, setSchedulePostHours] = useState(
    schedule ? schedule.hours : 0
  );
  const [schedulePostTime, setSchedulePostTime] = useState(
    schedule ? schedule.time : "AM"
  );
  const [error, setError] = useState();
  const onSchedule = () => {
    if (!schedulePostDate) {
      setError("Date is required date");
      return;
    }
    const today = new Date();
    const dataArray = schedulePostDate.split("-");
    let dateSchedule;

    if (schedulePostTime === "AM") {
      dateSchedule = new Date(
        dataArray[0],
        dataArray[1] - 1,
        dataArray[2],
        schedulePostHours,
        schedulePostMinutes,
        0
      );
    } else {
      let hours;
      if (schedulePostHours === 0) {
        hours = 12;
      } else {
        hours = parseInt(schedulePostHours) + 12;
      }
      dateSchedule = new Date(
        dataArray[0],
        dataArray[1] - 1,
        dataArray[2],
        hours,
        schedulePostMinutes,
        0
      );
    }
    if (dateSchedule.getTime() < today.getTime() + 1800000) {
      setError("The date must be later than the current one.");
      return;
    }

    for (let i = 0; i < drafPost.length; i++) {
      const time = new Date(drafPost[i].scheduled_dt)
      if (
        dateSchedule.getTime() > time.getTime() - 180000 &&
        dateSchedule.getTime() < time.getTime() + 180000
      ) {
        setError("You already have a post scheduled for that time range.");
        return;
      }
    }

    setSchedule({
      date: schedulePostDate,
      hours: schedulePostHours,
      minutes: schedulePostMinutes,
      time: schedulePostTime,
    });
    onHide();
  };

  const MINUTES = Array.from({ length: 60 }, (v, k) => ({
    key: k,
    value: k,
  }));

  const HOURS = Array.from({ length: 13 }, (v, k) => ({
    key: k,
    value: k,
  }));
  const TIME = Array({ key: "1", value: "AM" }, { key: "2", value: "PM" });

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <div>Schedule Post</div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {error && (
              <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold text-center">
                  {error}
                </div>
              </div>
            )}
            <div className="row justify-content-space-around">
              <div className="col">
                <Form.Group controlId="pickdate">
                  <Form.Label>Pick a date</Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      setSchedulePostDate(e.target.value);
                    }}
                    value={schedulePostDate}
                    name="pickdate"
                    type="date"
                  />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group controlId="picktime">
                  <Form.Label>Pick a time</Form.Label>
                  <div className="row justify-content-end">
                    <div className="col-4">
                      <Form.Control
                        name="hours"
                        type="hours"
                        as="select"
                        onChange={(e) => setSchedulePostHours(e.target.value)}
                        value={schedulePostHours}
                      >
                        {HOURS.map((hour) => (
                          <option key={hour.key}>{hour.value}</option>
                        ))}
                      </Form.Control>
                    </div>
                    <div className="col-4">
                      <Form.Control
                        name="minutes"
                        type="minutes"
                        as="select"
                        onChange={(e) => setSchedulePostMinutes(e.target.value)}
                        value={schedulePostMinutes}
                      >
                        {MINUTES.map((minute) => (
                          <option key={minute.key}>{minute.value}</option>
                        ))}
                      </Form.Control>
                    </div>
                    <div className="col-4">
                      <Form.Control
                        name="time"
                        as="select"
                        onChange={(e) => setSchedulePostTime(e.target.value)}
                        value={schedulePostTime}
                      >
                        {TIME.map((time) => (
                          <option key={time.key}>{time.value}</option>
                        ))}
                      </Form.Control>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <div className="mr-2">
                <Button onClick={() => onHide()}>Cancel</Button>
              </div>
              <div>
                <Button onClick={() => onSchedule()}>Schedule</Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(SchedulePostDialog);
